import React, { FC } from 'react';

import Angelinas from './organisms/Angelinas';
import CameronSeafood from './organisms/CameronsSeafood';
import Default from './organisms/Default';
import GetMaineLobster from './organisms/GetMaineLobster';
import Miette from './organisms/Miette';
import Raos from './organisms/Raos';
import { IPrizeMerchant } from '../../types';

interface MenuProps {
  merchant: IPrizeMerchant;
}

const Menu: FC<MenuProps> = ({ merchant }) => {
  switch ( merchant.prizeFilePath ) {
    case 'angelinas_of_maryland':
      return <Angelinas merchant={merchant} />;
    case 'camerons_seafood':
      return <CameronSeafood merchant={merchant} />;
    case 'get_maine_lobster':
      return <GetMaineLobster merchant={merchant} />;
    case 'miette':
      return <Miette merchant={merchant} />;
    case 'raos':
      return <Raos merchant={merchant} />;
    default:
      return <Default merchant={merchant} />;
  }
};

export default Menu;
